// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VelocitySimulation__footer___sm4gO {
    bottom: 0;
    left: 0;

    justify-content: flex-end;

    width: 100%;
    height: 4rem;
}

.VelocitySimulation__activeItem___F64Be {
    background-color: var(--color-control-typo-secondary);
}

.VelocitySimulation__item___PJgQX {
    height: 2.4rem;
    border-radius: 0.4rem;
}

.VelocitySimulation__wrapper___tbQCy > .VelocitySimulation__activeItemText___t342o {
    color: var(--color-bg-default);
}

.VelocitySimulation__keyItem___bInQY {
    max-width: 15.8rem;
}

.VelocitySimulation__bodyDisabled___T7b2M {
    pointer-events: none;
    color: white;
    opacity: 0.5;
}

.VelocitySimulation__modalBody___NWKnw {
    display: flex;
}

.VelocitySimulation__modalRight___mFL_w {
    padding: 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/VelocitySimulation/VelocitySimulation.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,OAAO;;IAEP,yBAAyB;;IAEzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".footer {\n    bottom: 0;\n    left: 0;\n\n    justify-content: flex-end;\n\n    width: 100%;\n    height: 4rem;\n}\n\n.activeItem {\n    background-color: var(--color-control-typo-secondary);\n}\n\n.item {\n    height: 2.4rem;\n    border-radius: 0.4rem;\n}\n\n.wrapper > .activeItemText {\n    color: var(--color-bg-default);\n}\n\n.keyItem {\n    max-width: 15.8rem;\n}\n\n.bodyDisabled {\n    pointer-events: none;\n    color: white;\n    opacity: 0.5;\n}\n\n.modalBody {\n    display: flex;\n}\n\n.modalRight {\n    padding: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `VelocitySimulation__footer___sm4gO`,
	"activeItem": `VelocitySimulation__activeItem___F64Be`,
	"item": `VelocitySimulation__item___PJgQX`,
	"wrapper": `VelocitySimulation__wrapper___tbQCy`,
	"activeItemText": `VelocitySimulation__activeItemText___t342o`,
	"keyItem": `VelocitySimulation__keyItem___bInQY`,
	"bodyDisabled": `VelocitySimulation__bodyDisabled___T7b2M`,
	"modalBody": `VelocitySimulation__modalBody___NWKnw`,
	"modalRight": `VelocitySimulation__modalRight___mFL_w`
};
export default ___CSS_LOADER_EXPORT___;
